import * as React from "react";
import { FieldRow, FieldsTable } from "@/components/molecules/FieldsTable";
import { Responsible } from "./Responsible";
import { readableAccountNextSteps } from "@/utils/accounts";
import { AccountDisplayInfo } from "./AccountDetails";

type CreditCardsAccountProps = AccountDisplayInfo;

export const CreditCardsAccount: React.FC<CreditCardsAccountProps> = ({
  persons,
  account: { serviceProviderType, accountNumber, nextSteps, responsibleId },
}) => {
  return (
    <FieldsTable>
      <FieldRow label="Credit card number" value={accountNumber} />

      <FieldRow
        label="Next Step"
        value={readableAccountNextSteps(nextSteps, serviceProviderType)}
      />

      <FieldRow
        label="Responsible"
        value={<Responsible persons={persons} responsibleId={responsibleId} />}
      />
    </FieldsTable>
  );
};
